import { AxiosAgentBuilder, IApiClientConfiguration, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  AdminResource,
  AlertResource,
  AnnouncementResource,
  AntivirusResource,
  ApiKeyResource,
  AuthResource,
  AutocompleteSuggestionsResource,
  BillingAccountAssignmentResource,
  BillingAccountResource,
  BreakPolicyResource,
  ChargeResource,
  ConnectedAccountResource,
  CustomLinkResource,
  CustomSchemaResource,
  DataRetentionScheduleResource,
  DeviceResource,
  DispatcherOperationsResource,
  DriverBehaviourResource,
  DriverBreakReasonResource,
  DriverOperationsResource,
  DriverResource,
  DutyDelayResource,
  DutyRequestOfferResource,
  DutyResource,
  EmailResource,
  EstimateResource,
  ExternalDispatchResource,
  FarePassAllocationResource,
  FarePassResource,
  FareRedemptionResource,
  FareRuleResource,
  FavoriteLocationResource,
  FileResource,
  FleetMetricsResource,
  FleetResource,
  GlobalUserResource,
  GroupMembershipResource,
  GroupResource,
  JourneyEstimateResource,
  JourneyOptionsResource,
  MetabaseResource,
  MobileAppResource,
  NotificationAnalyticsResource,
  NotificationSettingResource,
  OrganizationResource,
  PayCollectionCallResource,
  PaymentMethodResource,
  PlaceDetailsResource,
  PromoAllocationResource,
  PromoResource,
  PublicResource,
  QuickReplyResource,
  ReportResource,
  RequestDailyCountResource,
  RequestHistoryResource,
  RequestPredictionResource,
  RequestRecurrenceResource,
  RequestResource,
  ReverseGeocodeResource,
  ReviewResource,
  RiderDriverRestrictionResource,
  RiderResource,
  RiderRiderRestrictionResource,
  RiderVehicleTypeRestrictionResource,
  RouteAssignmentResource,
  RouteOptimizationResource,
  RouteResource,
  ServiceFleetResource,
  ServiceMetricsResource,
  ServiceResource,
  SlotResource,
  SmsResource,
  StopResource,
  SupportedClientsResource,
  TicketInstanceResource,
  TimeRuleResource,
  TipPolicyResource,
  TokenContextResource,
  UploadResource,
  UserBanResource,
  UserResource,
  VehicleInspectionResource,
  VehicleInspectionTemplateResource,
  VehicleLocationResource,
  VehicleResource,
  WebhookResource,
  WorkOsResource,
  ZoneAreaResource,
  ZoneResource,
} from '../resources'
import { AccessGrantResource } from '../resources/AccessGrantResource'
import { AnalyzeReportJobResource } from '../resources/AnalyzeReportJobResource'
import { AppInstallationResource } from '../resources/AppInstallationResource'
import { AppResource } from '../resources/AppResource'
import { AppWebhookResource } from '../resources/AppWebhookResource'
import { AuthorizationGroupMembershipResource } from '../resources/AuthorizationGroupMembershipResource'
import { AuthorizationGroupResource } from '../resources/AuthorizationGroupResource'
import { AuthorizationPermissionResource } from '../resources/AuthorizationPermissionResource'
import { AuthorizationPermissionSetResource } from '../resources/AuthorizationPermissionSetResource'
import { AuthorizationRoleResource } from '../resources/AuthorizationRoleResource'
import { BulkNotificationResource } from '../resources/BulkNotificationResource'
import { CallCentreMetricsResource } from '../resources/CallCentreMetricsResource'
import { CancellationReasonResource } from '../resources/CancellationReasonsResource'
import { DriverBreakResource } from '../resources/DriverBreakResource'
import { DriverMetricsResource } from '../resources/DriverMetricsResource'
import { DutyConversationResource } from '../resources/DutyConversationResource'
import { EstimateOverrideResource } from '../resources/EstimateOverrideResource'
import { EventResource } from '../resources/EventResource'
import { GeocodeResource } from '../resources/GeocodeResource'
import { GlobalResource } from '../resources/GlobalResource'
import { GroupConditionResource } from '../resources/GroupConditionResource'
import { IvrCallMetricsResource } from '../resources/IvrCallMetricsResource'
import { JourneyResource } from '../resources/JourneyResource'
import { LyftInstallationResource } from '../resources/LyftInstallationResource'
import { MatchingSimulationResource } from '../resources/MatchingSimulationResource'
import { MobileAppReleaseResource } from '../resources/MobileAppReleaseResource'
import { NotificationProviderConfigurationResource } from '../resources/NotificationProviderConfigurationResource'
import { OAuthAuthorizeResource } from '../resources/OAuthResource'
import { PaymentMethodTypeResource } from '../resources/PaymentMethodTypeResource'
import { PaymentProviderResource } from '../resources/PaymentProviderResource'
import { PleoResource } from '../resources/PleoResource'
import { ProviderResource } from '../resources/ProviderResource'
import { ReportTemplatesResource } from '../resources/ReportTemplatesResource'
import { RiderMetricsResource } from '../resources/RiderMetricsResource'
import { RiderOnboardingResource } from '../resources/RiderOnboardingResource'
import { RiderRepresentativeResource } from '../resources/RiderRepresentativeResource'
import { SmsDeliveryErrorResource } from '../resources/SmsDeliveryErrorResource'
import { SuperAdminAuthorizationPermissionResource } from '../resources/SuperAdminAuthorizationPermissionResource'
import { SuperAdminAuthorizationRoleResource } from '../resources/SuperAdminAuthorizationRoleResource'
import { TriggeredOptimizationResource } from '../resources/TriggeredOptimizationResource'
import { TripGroupResource } from '../resources/TripGroupResource'
import { UserFleetAgreementResource } from '../resources/UserFleetAgreementResource'
import { UserRoleResource } from '../resources/UserRoleResource'
import { UserSettingsResource } from '../resources/UserSettingsResource'
import { VehicleTypeResource } from '../resources/VehicleTypeResource'
import { WalletAutoTopUpResource } from '../resources/WalletAutoTopUpResource'

export class ApiClient {
  public auth: AuthResource
  public analyzeReportJobs: AnalyzeReportJobResource
  public workos: WorkOsResource
  public metabase: MetabaseResource
  public fleets: FleetResource
  public paymentMethods: PaymentMethodResource
  public paymentMethodTypes: PaymentMethodTypeResource
  public paymentProviders: PaymentProviderResource
  public requests: RequestResource
  public stops: StopResource
  public vehicles: VehicleResource
  public vehicleLocations: VehicleLocationResource
  public services: ServiceResource
  public users: UserResource
  public riders: RiderResource
  public drivers: DriverResource
  public admins: AdminResource
  public userSettings: UserSettingsResource
  public serviceFleets: ServiceFleetResource
  public webhooks: WebhookResource
  public zones: ZoneResource
  public duties: DutyResource
  public slots: SlotResource
  public driverOperations: DriverOperationsResource
  public estimates: EstimateResource
  public estimatesOverride: EstimateOverrideResource
  public journeyEstimates: JourneyEstimateResource
  public journeyOptions: JourneyOptionsResource
  public upload: UploadResource
  public organizations: OrganizationResource
  public reports: ReportResource
  public supportedClients: SupportedClientsResource
  public announcements: AnnouncementResource
  public apiKeys: ApiKeyResource
  public customLinks: CustomLinkResource
  public charges: ChargeResource
  public dataRetentionSchedule: DataRetentionScheduleResource
  public devices: DeviceResource
  public dutyRequestOffers: DutyRequestOfferResource
  public farePasses: FarePassResource
  public farePassAllocations: FarePassAllocationResource
  public fareRedemptions: FareRedemptionResource
  public fareRules: FareRuleResource
  public favoriteLocations: FavoriteLocationResource
  public groups: GroupResource
  public groupMemberships: GroupMembershipResource
  public groupConditions: GroupConditionResource
  public notificationSettings: NotificationSettingResource
  public bulkNotifications: BulkNotificationResource
  public promos: PromoResource
  public promoAllocations: PromoAllocationResource
  public requestRecurrences: RequestRecurrenceResource
  public reviews: ReviewResource
  public routeOptimization: RouteOptimizationResource
  public timeRules: TimeRuleResource
  public userBans: UserBanResource
  public customSchemas: CustomSchemaResource
  public serviceMetrics: ServiceMetricsResource
  public riderMetrics: RiderMetricsResource
  public driverMetrics: DriverMetricsResource
  public fleetMetrics: FleetMetricsResource
  public callCentreMetrics: CallCentreMetricsResource
  public ivrCallMetrics: IvrCallMetricsResource
  public public: PublicResource
  public files: FileResource
  public tipPolicies: TipPolicyResource
  public tokenContext: TokenContextResource
  public connectedAccounts: ConnectedAccountResource
  public alerts: AlertResource
  public routes: RouteResource
  public routeAssignments: RouteAssignmentResource
  public externalDispatch: ExternalDispatchResource
  public places: {
    autocompleteSuggestions: AutocompleteSuggestionsResource
    placeDetails: PlaceDetailsResource
    reverseGeocode: ReverseGeocodeResource
    geocode: GeocodeResource
  }

  public emails: EmailResource
  public sms: SmsResource
  public mobileApps: MobileAppResource
  public mobileAppRelease: MobileAppReleaseResource
  public billingAccounts: BillingAccountResource
  public billingAccountAssignments: BillingAccountAssignmentResource
  public apps: AppResource
  public appInstallations: AppInstallationResource
  public appWebhooks: AppWebhookResource
  public oAuthAuthorize: OAuthAuthorizeResource
  public lyftInstallation: LyftInstallationResource
  public reportTemplates: ReportTemplatesResource
  public breakPolicies: BreakPolicyResource
  public driverBreaks: DriverBreakResource
  public driverBreakReasons: DriverBreakReasonResource
  public global: GlobalResource
  public globalUser: GlobalUserResource
  public requestDailyCounts: RequestDailyCountResource
  public userFleetAgreements: UserFleetAgreementResource
  public events: EventResource
  public antivirus: AntivirusResource
  public matchingSimulations: MatchingSimulationResource
  public triggeredOptimizations: TriggeredOptimizationResource
  public notificationAnalytics: NotificationAnalyticsResource
  public pleo: PleoResource
  public dispatcherOperations: DispatcherOperationsResource
  public notificationProviderConfigurations: NotificationProviderConfigurationResource
  public vehicleInspections: VehicleInspectionResource
  public vehicleInspectionTemplates: VehicleInspectionTemplateResource
  public vehicleTypes: VehicleTypeResource
  public providers: ProviderResource
  public riderVehicleTypeRestrictions: RiderVehicleTypeRestrictionResource
  public riderDriverRestrictions: RiderDriverRestrictionResource
  public driverBehaviours: DriverBehaviourResource
  public riderRiderRestrictions: RiderRiderRestrictionResource
  public walletAutoTopUp: WalletAutoTopUpResource
  public dutyConversation: DutyConversationResource
  public riderOnboardingFlow: RiderOnboardingResource
  public journeyResource: JourneyResource
  public dutyDelay: DutyDelayResource
  public requestPredictions: RequestPredictionResource
  public cancellationReasons: CancellationReasonResource
  public accessGrants: AccessGrantResource
  public authorizationRole: AuthorizationRoleResource
  public authorizationGroup: AuthorizationGroupResource
  public authorizationGroupMembership: AuthorizationGroupMembershipResource
  public authorizationPermissionSets: AuthorizationPermissionSetResource
  public authorizationPermission: AuthorizationPermissionResource
  public superAdminAuthorizationRole: SuperAdminAuthorizationRoleResource
  public superAdminAuthorizationPermission: SuperAdminAuthorizationPermissionResource
  public userRole: UserRoleResource
  public ticketInstance: TicketInstanceResource
  public zoneAreas: ZoneAreaResource
  public riderRepresentatives: RiderRepresentativeResource
  public payCollectionCalls: PayCollectionCallResource
  public tripGroups: TripGroupResource
  public requestHistories: RequestHistoryResource
  public smsDeliveryErrors: SmsDeliveryErrorResource
  public quickReplies: QuickReplyResource

  // Note: in most cases people will use `ApiClient.build` as a more convenient way to create an `ApiClient`
  constructor(agent: IHttpAgent) {
    this.auth = new AuthResource(agent)
    this.analyzeReportJobs = new AnalyzeReportJobResource(agent)
    this.workos = new WorkOsResource(agent)
    this.metabase = new MetabaseResource(agent)
    this.fleets = new FleetResource(agent)
    this.paymentMethods = new PaymentMethodResource(agent)
    this.paymentMethodTypes = new PaymentMethodTypeResource(agent)
    this.paymentProviders = new PaymentProviderResource(agent)
    this.estimates = new EstimateResource(agent)
    this.estimatesOverride = new EstimateOverrideResource(agent)
    this.journeyEstimates = new JourneyEstimateResource(agent)
    this.journeyOptions = new JourneyOptionsResource(agent)
    this.requests = new RequestResource(agent)
    this.stops = new StopResource(agent)
    this.vehicles = new VehicleResource(agent)
    this.vehicleLocations = new VehicleLocationResource(agent)
    this.services = new ServiceResource(agent)
    this.users = new UserResource(agent)
    this.riders = new RiderResource(agent)
    this.drivers = new DriverResource(agent)
    this.admins = new AdminResource(agent)
    this.userSettings = new UserSettingsResource(agent)
    this.serviceFleets = new ServiceFleetResource(agent)
    this.webhooks = new WebhookResource(agent)
    this.zones = new ZoneResource(agent)
    this.duties = new DutyResource(agent)
    this.slots = new SlotResource(agent)
    this.driverOperations = new DriverOperationsResource(agent)
    this.upload = new UploadResource(agent)
    this.organizations = new OrganizationResource(agent)
    this.reports = new ReportResource(agent)
    this.supportedClients = new SupportedClientsResource(agent)
    this.announcements = new AnnouncementResource(agent)
    this.apiKeys = new ApiKeyResource(agent)
    this.customLinks = new CustomLinkResource(agent)
    this.charges = new ChargeResource(agent)
    this.dataRetentionSchedule = new DataRetentionScheduleResource(agent)
    this.devices = new DeviceResource(agent)
    this.dutyRequestOffers = new DutyRequestOfferResource(agent)
    this.farePasses = new FarePassResource(agent)
    this.farePassAllocations = new FarePassAllocationResource(agent)
    this.fareRedemptions = new FareRedemptionResource(agent)
    this.fareRules = new FareRuleResource(agent)
    this.favoriteLocations = new FavoriteLocationResource(agent)
    this.groups = new GroupResource(agent)
    this.groupMemberships = new GroupMembershipResource(agent)
    this.groupConditions = new GroupConditionResource(agent)
    this.notificationSettings = new NotificationSettingResource(agent)
    this.bulkNotifications = new BulkNotificationResource(agent)
    this.promos = new PromoResource(agent)
    this.promoAllocations = new PromoAllocationResource(agent)
    this.requestRecurrences = new RequestRecurrenceResource(agent)
    this.reviews = new ReviewResource(agent)
    this.routeOptimization = new RouteOptimizationResource(agent)
    this.timeRules = new TimeRuleResource(agent)
    this.userBans = new UserBanResource(agent)
    this.customSchemas = new CustomSchemaResource(agent)
    this.serviceMetrics = new ServiceMetricsResource(agent)
    this.fleetMetrics = new FleetMetricsResource(agent)
    this.callCentreMetrics = new CallCentreMetricsResource(agent)
    this.ivrCallMetrics = new IvrCallMetricsResource(agent)
    this.public = new PublicResource(agent)
    this.files = new FileResource(agent)
    this.tipPolicies = new TipPolicyResource(agent)
    this.tokenContext = new TokenContextResource(agent)
    this.connectedAccounts = new ConnectedAccountResource(agent)
    this.emails = new EmailResource(agent)
    this.sms = new SmsResource(agent)
    this.alerts = new AlertResource(agent)
    this.mobileApps = new MobileAppResource(agent)
    this.mobileAppRelease = new MobileAppReleaseResource(agent)
    this.routes = new RouteResource(agent)
    this.routeAssignments = new RouteAssignmentResource(agent)
    this.externalDispatch = new ExternalDispatchResource(agent)
    this.places = {
      autocompleteSuggestions: new AutocompleteSuggestionsResource(agent),
      placeDetails: new PlaceDetailsResource(agent),
      reverseGeocode: new ReverseGeocodeResource(agent),
      geocode: new GeocodeResource(agent),
    }
    this.billingAccounts = new BillingAccountResource(agent)
    this.billingAccountAssignments = new BillingAccountAssignmentResource(agent)
    this.apps = new AppResource(agent)
    this.appInstallations = new AppInstallationResource(agent)
    this.appWebhooks = new AppWebhookResource(agent)
    this.oAuthAuthorize = new OAuthAuthorizeResource(agent)
    this.lyftInstallation = new LyftInstallationResource(agent)
    this.breakPolicies = new BreakPolicyResource(agent)
    this.driverBreaks = new DriverBreakResource(agent)
    this.driverBreakReasons = new DriverBreakReasonResource(agent)
    this.global = new GlobalResource(agent)
    this.globalUser = new GlobalUserResource(agent)
    this.requestDailyCounts = new RequestDailyCountResource(agent)
    this.userFleetAgreements = new UserFleetAgreementResource(agent)
    this.events = new EventResource(agent)
    this.antivirus = new AntivirusResource(agent)
    this.reportTemplates = new ReportTemplatesResource(agent)
    this.matchingSimulations = new MatchingSimulationResource(agent)
    this.triggeredOptimizations = new TriggeredOptimizationResource(agent)
    this.notificationAnalytics = new NotificationAnalyticsResource(agent)
    this.pleo = new PleoResource(agent)
    this.dispatcherOperations = new DispatcherOperationsResource(agent)
    this.notificationProviderConfigurations = new NotificationProviderConfigurationResource(agent)
    this.vehicleInspections = new VehicleInspectionResource(agent)
    this.vehicleInspectionTemplates = new VehicleInspectionTemplateResource(agent)
    this.vehicleTypes = new VehicleTypeResource(agent)
    this.providers = new ProviderResource(agent)
    this.riderVehicleTypeRestrictions = new RiderVehicleTypeRestrictionResource(agent)
    this.walletAutoTopUp = new WalletAutoTopUpResource(agent)
    this.dutyConversation = new DutyConversationResource(agent)
    this.riderOnboardingFlow = new RiderOnboardingResource(agent)
    this.journeyResource = new JourneyResource(agent)
    this.dutyDelay = new DutyDelayResource(agent)
    this.requestPredictions = new RequestPredictionResource(agent)
    this.riderMetrics = new RiderMetricsResource(agent)
    this.driverMetrics = new DriverMetricsResource(agent)
    this.cancellationReasons = new CancellationReasonResource(agent)
    this.accessGrants = new AccessGrantResource(agent)
    this.authorizationRole = new AuthorizationRoleResource(agent)
    this.authorizationGroup = new AuthorizationGroupResource(agent)
    this.authorizationGroupMembership = new AuthorizationGroupMembershipResource(agent)
    this.authorizationPermission = new AuthorizationPermissionResource(agent)
    this.authorizationPermissionSets = new AuthorizationPermissionSetResource(agent)
    this.superAdminAuthorizationRole = new SuperAdminAuthorizationRoleResource(agent)
    this.superAdminAuthorizationPermission = new SuperAdminAuthorizationPermissionResource(agent)
    this.userRole = new UserRoleResource(agent)
    this.ticketInstance = new TicketInstanceResource(agent)
    this.zoneAreas = new ZoneAreaResource(agent)
    this.riderDriverRestrictions = new RiderDriverRestrictionResource(agent)
    this.riderRiderRestrictions = new RiderRiderRestrictionResource(agent)
    this.riderRepresentatives = new RiderRepresentativeResource(agent)
    this.payCollectionCalls = new PayCollectionCallResource(agent)
    this.driverBehaviours = new DriverBehaviourResource(agent)
    this.tripGroups = new TripGroupResource(agent)
    this.requestHistories = new RequestHistoryResource(agent)
    this.smsDeliveryErrors = new SmsDeliveryErrorResource(agent)
    this.quickReplies = new QuickReplyResource(agent)
  }

  public static build(configuration: IApiClientConfiguration): ApiClient {
    return new ApiClient(AxiosAgentBuilder.build(configuration))
  }
}
